import { styled } from '@mui/material';

import { Typography, Box, FakeInput } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

export type ScenarioReportLinkProps = {
  shareLink: string;
};

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const ShareReportLink = ({ shareLink }: ScenarioReportLinkProps) => {
  const { t } = useI18n();

  return (
    <Box>
      <StyledTypography variant="body2">
        {t('reports:share_report_link')}:
      </StyledTypography>
      <FakeInput>{shareLink}</FakeInput>
    </Box>
  );
};
